import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ServiceIcon = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
);

const ServerIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/><rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
        <line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/>
    </svg>
);

const DatabaseIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="5" rx="9" ry="3"/>
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
    </svg>
);

const LogoutIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16 17 21 12 16 7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
);

const BrandIcon = () => (
    <svg viewBox="0 0 24 24" fill="white">
        <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
    </svg>
);

const RefreshIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 4 23 10 17 10"/>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
    </svg>
);

export const Header = ({ title, subtitle, onRefresh, children }) => {
    const location = useLocation();

    const navItems = [
        { to: '/home',      label: 'Services',  Icon: ServiceIcon  },
        { to: '/servers',   label: 'Servers',   Icon: ServerIcon   },
        { to: '/databases', label: 'Databases', Icon: DatabaseIcon },
    ];

    return (
        <div className="app-layout">
            <aside className="sidebar">
                <div className="sidebar-brand">
                    <div className="brand-icon">
                        <BrandIcon />
                    </div>
                    <div className="brand-name">
                        <strong>ServiceOps</strong>
                        <span>Monitor &amp; Control</span>
                    </div>
                </div>

                <nav className="sidebar-body">
                    <span className="nav-section-label">Navigation</span>
                    {navItems.map(({ to, label, Icon }) => (
                        <Link
                            key={to}
                            to={to}
                            className={`nav-link${location.pathname === to ? ' active' : ''}`}
                        >
                            <Icon />
                            {label}
                        </Link>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <Link to="/" className="nav-link logout">
                        <LogoutIcon />
                        Logout
                    </Link>
                </div>
            </aside>

            <div className="main-content">
                <header className="topbar">
                    <div className="topbar-left">
                        <span className="topbar-title">{title}</span>
                        {subtitle && <span className="topbar-subtitle">{subtitle}</span>}
                    </div>
                    <div className="topbar-right">
                        {onRefresh && (
                            <button className="btn btn-ghost" onClick={onRefresh}>
                                <RefreshIcon />
                                Refresh
                            </button>
                        )}
                    </div>
                </header>

                <main className="page-content">
                    {children}
                </main>
            </div>
        </div>
    );
};
